<template>
  <img
    v-bind="$attrs"
    :src="resolvedSrc"
    :loading="resolvedLoading"
    :decoding="resolvedDecoding"
    :fetchpriority="resolvedFetchPriority"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: "AppImage",
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      default: "",
    },
    eager: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: String,
      default: "",
    },
    decoding: {
      type: String,
      default: "async",
    },
    fetchpriority: {
      type: String,
      default: "",
    },
  },
  computed: {
    resolvedSrc() {
      const src = (this.src || "").trim();
      if (!src || src.includes("undefined") || /\/hyos\/ymg\/?$/.test(src)) {
        return "";
      }
      return src;
    },
    resolvedLoading() {
      if (this.loading) {
        return this.loading;
      }
      return this.eager ? "eager" : "lazy";
    },
    resolvedDecoding() {
      return this.decoding || "async";
    },
    resolvedFetchPriority() {
      if (this.fetchpriority) {
        return this.fetchpriority;
      }
      return this.eager ? "high" : "auto";
    },
  },
};
</script>

